'use client';

import { useI18n } from '@/modules/i18n/useI18n';
import ErrorPage from '@/payload/components/ErrorPage/ErrorPage';

export default function NotFound() {
	const { terms } = useI18n();

	return (
		<main data-tag-page-section="not-found">
			<ErrorPage title={terms.notFound.title} description={terms.notFound.description} label={terms.notFound.label} />
		</main>
	);
}
